module.exports = __webpack_public_path__ + "static/karthik-kumar-1d0dbd77c17b1d534a84fd7b98014ce3.png";